import { faStar } from "@jewlr/pro-solid-svg-icons/faStar"
import { faStarHalfAlt } from "@jewlr/pro-solid-svg-icons/faStarHalfAlt"
import { Box, FontAwesomeIcon, Flex, Typography } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

import { SectionTitle } from "areas/product/jewlr/components"

const Container = styled(Box).attrs({
  contain: true,
  pb: { _: 0, tablet: 5 },
  pt: 5,
  px: 2,
  textAlign: "center",
})``

const StyledIcon = styled(FontAwesomeIcon).attrs((props) => ({
  color: "#F7BF4D",
  fontSize: "24px",
  ...props,
}))``

const CustomerReviews = () => (
  <Container>
    <SectionTitle>OUR CUSTOMERS LOVE US</SectionTitle>
    <Typography
      fontSize="18px"
      fontWeight={700}
      lineHeight="20px"
      mb="2px"
      mt="22px"
      textTransform="uppercase"
    >
      50K+ REVIEWS
    </Typography>
    <Flex alignItems="center" gap="4px" justifyContent="center">
      {Array.from(Array(4)).map((el, i) => (
        <StyledIcon icon={faStar} key={i} />
      ))}
      <StyledIcon icon={faStarHalfAlt} />
    </Flex>
  </Container>
)

export default CustomerReviews
